/**
 * 파라미터가 객체인지 여부를 검사합니다. Array 도 객체로 평가됩니다.
 * @param v
 * @returns {boolean}
 */
export default (v) => typeof v === 'object';
